import { getDate } from '../dateUtils'

type PostTag = 'announcements' | 'governance' | 'trading' | 'ookiversity' | 'news' | 'defi-basics'

export interface IPostData {
  title: string
  date: string
  url: string
  image: string
  tags: PostTag[]
  excerpt: string
}

export interface BlogPostResponse {
  title: string
  updated_at: string
  feature_image: string
  url: string
  tags: { slug: PostTag }[]
  excerpt: string
  plaintext: string
}

export const ghostApiUrl = `https://bzx-protocol.ghost.io/ghost/api/v3/content/posts/?key=e8a35446590101d58c4bbb668d&fields=title,url,updated_at,feature_image,excerpt&formats=plaintext&limit=100&include=tags`
export const getBlogPosts = async (): Promise<IPostData[]> => {
  const blogRequest = await fetch(ghostApiUrl)
  if (blogRequest.status !== 200) {
    throw new Error('Could not fetch posts')
  }

  const blogResponse = await blogRequest.json()
  return blogResponse.posts.map((post: BlogPostResponse) => {
    return {
      title: post.title,
      date: getDate(post['updated_at']),
      url: post.url,
      image: post['feature_image'],
      excerpt: post.excerpt.replaceAll(/\[http.+\]/gm, ''),
      tags: post.tags.map((tag) => tag.slug),
    }
  })
}
